import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'deviceLampOperTime',
})
export class DeviceLampOperTimePipe implements PipeTransform {

  transform(rawValue: number): string | number {
    const valueFromApi = +rawValue;
    const toInt = (value: number) => Number( value.toFixed(1) );
    if (isNaN(valueFromApi)) {
      return rawValue;
    }

    if (valueFromApi === 999) {
      return `1 ${$localize`млн.`}`;
    }
    if (valueFromApi >= 1000) {
      const parsedValue = valueFromApi / 1000;
      return `${toInt(parsedValue)} ${$localize`млн.`}`;
    } else {
      return `${toInt(valueFromApi)} ${$localize`тыс.`}`;
    }
  }
}
